module.exports = __webpack_public_path__ + "static/favicon-3d7a25797194c9e982aaf4f365e59cd6.ico";